var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67285 3.75V28.25M26.1729 3.75V28.25M1.67285 9H8.67285M26.1729 9H33.1729M1.67285 23H8.67285M26.1729 23H33.1729M1.67285 16H8.67285M26.1729 16H33.1729M7.27285 30H27.5729C29.533 30 30.5131 30 31.2618 29.6185C31.9204 29.283 32.4558 28.7475 32.7914 28.089C33.1729 27.3403 33.1729 26.3602 33.1729 24.4V7.6C33.1729 5.63982 33.1729 4.65972 32.7914 3.91103C32.4558 3.25247 31.9204 2.71703 31.2618 2.38148C30.5131 2 29.533 2 27.5729 2H7.27285C5.31267 2 4.33258 2 3.58388 2.38148C2.92532 2.71703 2.38989 3.25247 2.05433 3.91103C1.67285 4.65972 1.67285 5.63982 1.67285 7.6V24.4C1.67285 26.3602 1.67285 27.3403 2.05433 28.089C2.38989 28.7475 2.92532 29.283 3.58388 29.6185C4.33258 30 5.31267 30 7.27285 30Z",
    stroke: "#2574EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.da9ff72f5b5fede194fa9d00d0692cd2.svg";
export { ForwardRef as ReactComponent };